export default __webpack_public_path__ + "static/media/industries.d642fa87.svg";